/**
 * @file paddle 客户案例 案例列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Col, Pagination, Row} from 'antd';
import classNames from 'classnames';

import A from '../../../../components/a/A';
import SwitchButton from './components/switch-button/SwitchButton';
import IconOrder from './components/icon-order/IconOrder';

import {useUniverseCaseListHooks} from './universeCaseListHooks';
import {ICaseListProps} from './types.d';

const CaseList: React.FC<ICaseListProps> = props => {
    const {
        caseList,
        pagination,
        schoolCaseSort,

        onSchoolCaseSortChange,
        onPageChange
    } = useUniverseCaseListHooks();

    return (
        <div className="paddle-cc-case-list">
            <div className="paddle-cc-case-list-filter-list">
                <span
                    className="paddle-cc-case-list-filter-list-item"
                    onClick={() => onSchoolCaseSortChange('2')}
                >
                    默认排序
                </span>
                <span className="paddle-cc-case-list-filter-list-item">
                    <SwitchButton
                        value={schoolCaseSort}
                        onChange={onSchoolCaseSortChange}
                        notEmpty
                    >
                        <SwitchButton.Item>
                            按时间排序 <IconOrder />
                        </SwitchButton.Item>
                        <SwitchButton.Item value="1">
                            时间从远到近 <IconOrder type="down" />
                        </SwitchButton.Item>
                        <SwitchButton.Item value="0">
                            时间从近到远 <IconOrder type="up" />
                        </SwitchButton.Item>
                    </SwitchButton>
                </span>
            </div>
            <div className="paddle-cc-case-list-body">
                <Row gutter={20}>
                    {caseList.map(item => (
                        <Col
                            className="paddle-cc-case-list-item-wrap"
                            xs={8}
                            key={item.id}
                        >
                            <div
                                className={classNames(
                                    'paddle-cc-case-list-item',
                                    !!item.casePath && 'paddle-cc-case-list-item-with-link'
                                )}
                            >
                                <A
                                    className="paddle-cc-case-list-item-inner"
                                    href={item.casePath}
                                    target
                                >
                                    <div
                                        className="paddle-cc-case-list-item-icon"
                                        style={{backgroundImage: item.logo ? `url(${item.logo})` : undefined}}
                                    />
                                    <div className="paddle-cc-case-list-item-title">
                                        {item.caseName}
                                    </div>
                                    <div className="paddle-cc-case-list-item-text">
                                        {item.des}
                                    </div>
                                </A>
                                <div className="paddle-cc-case-list-item-about">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>
                                                相关产品：
                                            </td>
                                            <td>
                                                {item.products.pc.map(p => (
                                                    <A
                                                        className="paddle-cc-case-list-item-about-link"
                                                        key={`${p.href}${p.name}`}
                                                        href={p.href}
                                                        target
                                                    >
                                                        {p.name}
                                                    </A>
                                                ))}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <div className="paddle-cc-case-list-pagination">
                    {pagination.pageSize < pagination.total
                    && (
                        <Pagination {...pagination} onChange={onPageChange} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CaseList;
